import React from "react";
import { Typography, Space, Flex } from "antd";
import InfoHint from "./InfoHint";

const { Title, Text } = Typography;

// Consistent page title block: title + optional subtitle on the left, actions on the right.
// Pass `tooltip` to show a small info icon next to the title.
export default function PageHeader({ title, subtitle, extra, icon, tooltip }) {
  return (
    <Flex
      justify="space-between"
      align="center"
      wrap="wrap"
      gap={12}
      style={{ marginBottom: 16 }}
    >
      <Space align="center" size={12}>
        {icon}
        <div>
          <Title level={3} style={{ margin: 0, lineHeight: 1.2 }}>
            {title}
            <InfoHint title={tooltip} iconStyle={{ fontSize: 15 }} />
          </Title>
          {subtitle && (
            <Text type="secondary" style={{ fontSize: 13 }}>
              {subtitle}
            </Text>
          )}
        </div>
      </Space>
      {extra && <Space wrap className="ph-extra">{extra}</Space>}
    </Flex>
  );
}
